export const STEPPER_STATUS = {
  ACTIVE: "active",
  COMPLETED: "completed",
  INACTIVE: "inactive",
};
